import { BiometricDataPoint } from 'services/biometricsService';

export interface BloodPressureReading {
  id: number;
  date: string;
  timestamp: string;
  systolic: number;
  diastolic: number;
}

export const READINGS_PER_PAGE = 7;

/** Complete readings (both values present), oldest -> newest. */
export const toCompleteReadings = (
  data: BiometricDataPoint[] | undefined,
): BloodPressureReading[] =>
  (data ?? [])
    .flatMap(({ id, date, timestamp, values }) => {
      const [systolic, diastolic] = values ?? [];
      return systolic != null && diastolic != null
        ? [{ id, date, timestamp, systolic, diastolic }]
        : [];
    })
    .sort((a, b) => a.timestamp.localeCompare(b.timestamp));

/**
 * One page of up to 7 readings, oldest -> newest. Page 0 is the newest 7 and each page after steps
 * back 7 readings, so months without readings collapse and the last page is the oldest (possibly
 * shorter) set.
 */
export const pageOfReadings = (
  readings: BloodPressureReading[],
  pageIndex: number,
): { items: BloodPressureReading[]; hasOlder: boolean; hasNewer: boolean } => {
  const end = readings.length - pageIndex * READINGS_PER_PAGE;
  const start = Math.max(0, end - READINGS_PER_PAGE);
  return {
    items: readings.slice(start, Math.max(0, end)),
    hasOlder: start > 0,
    hasNewer: pageIndex > 0,
  };
};

/** "min-max", or "--" when there are no values. */
export const range = (values: number[]): string =>
  values.length ? `${Math.min(...values)}-${Math.max(...values)}` : '--';
